import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tipsy-ui/tipsy-ui/icons/LoadingImg.tsx");
